import styled from 'styled-components';
import { Fonts, Palette } from '../../../../../components/utils';

export const RateTypeSelectPlaceholder = styled.div`
  align-self: stretch;
  justify-content: flex-start;
  color: ${Palette.BLACK_50};
  font-size: 14px;
  font-weight: 400;
  font-family: ${Fonts.OPEN_SANS_FONT}, sans-serif;
  line-height: 24px;
`;

export const FieldRest = styled.div`
  align-self: stretch;
  padding: 12px 16px;
  background: ${Palette.SOLITUDE};
  border-radius: 8px;
  display: inline-flex;
  justify-content: space-between;
  align-items: center;
  gap: 8px;
  min-height: 48px;
  box-sizing: border-box;
`;

export const SelectInFieldWrapper = styled.div`
  flex: 1;
  min-width: 0;

  .ant-select {
    width: 100% !important;
  }

  /* Chevron is rendered as a sibling in FieldRest (same pattern as Building row). */
  .ant-select-arrow {
    display: none !important;
  }

  .ant-select-selector {
    background: transparent !important;
    border: none !important;
    box-shadow: none !important;
    padding-left: 0 !important;
    padding-right: 0 !important;
    min-height: 24px !important;
    height: auto !important;
  }

  .ant-select-selection-item,
  .ant-select-selection-placeholder {
    color: ${Palette.BLACK_50} !important;
    font-size: 14px !important;
    font-family: ${Fonts.OPEN_SANS_FONT}, sans-serif !important;
    font-weight: 400 !important;
    line-height: 24px !important;
  }
`;

export const ToggleBlock = styled.div`
  align-self: stretch;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  box-sizing: border-box;
`;

export const ToggleRow = styled.div`
  align-self: stretch;
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 12px;
  box-sizing: border-box;
`;

export const ToggleCopy = styled.div`
  flex: 1 1 0;
  min-width: 0;
  max-width: calc(100% - 56px);
  display: inline-flex;
  flex-direction: column;
  align-items: flex-start;
`;

export const ToggleSwitchWrap = styled.div`
  flex: 0 0 auto;
  flex-shrink: 0;
  align-self: center;
`;

export const ToggleTitle = styled.div`
  color: ${Palette.BLACK};
  font-size: 14px;
  font-family: ${Fonts.OPEN_SANS_FONT}, sans-serif;
  font-weight: 600;
  line-height: 24px;
`;

export const ToggleDescription = styled.div`
  color: ${Palette.CONTENT_TERTIARY};
  font-size: 14px;
  font-family: ${Fonts.OPEN_SANS_FONT}, sans-serif;
  font-weight: 400;
  line-height: 24px;
`;

export const BookingLimitsHeaderDescription = styled(ToggleDescription)`
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 100%;
`;

export const BookingLimitsSection = styled.div`
  align-self: stretch;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;
  width: 100%;
  max-width: none;
`;

export const BookingLimitsHeaderRow = styled.div`
  align-self: stretch;
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 12px;
  flex-wrap: nowrap;
  box-sizing: border-box;
  min-width: 0;
`;

export const BookingLimitsHeaderCopy = styled.div`
  flex: 1;
  min-width: 0;
  display: inline-flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 0;
  overflow: hidden;
`;

export const UnitPillDropdownContainer = styled.div`
  position: relative;
  display: inline-block;
  flex-shrink: 0;
  width: 90px;
`;

export const UnitPillButton = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: space-between;
  width: 90px;
  height: 32px;
  padding: 0 12px;
  background: ${Palette.WHITE};
  border-radius: 16px;
  border: 1px solid ${({ $isOpen }) => ($isOpen ? Palette.HAZY_BLUE : Palette.BORDER_OUTLINE)};
  cursor: pointer;
  font-family: inherit;
  color: ${Palette.BLACK};
  font-size: 13px;
  font-weight: 600;
  transition: all 0.2s ease;
  outline: none;

  &:hover {
    border-color: ${Palette.HAZY_BLUE};
  }

  svg {
    transition: transform 0.2s ease;
    transform: ${({ $isOpen }) => ($isOpen ? 'rotate(180deg)' : 'rotate(0deg)')};
    color: ${Palette.BLACK_50};
  }
`;

export const UnitPillDropdownMenu = styled.div`
  position: absolute;
  top: calc(100% + 4px);
  left: 0;
  right: 0;
  width: 100%;
  box-sizing: border-box;
  background: ${Palette.WHITE};
  border: 1px solid ${Palette.BORDER_OUTLINE};
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
  padding: 4px 0;
  z-index: 10000;
`;

export const UnitPillDropdownItem = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 8px 16px;
  cursor: pointer;
  font-size: 13px;
  font-weight: ${({ $selected }) => ($selected ? '600' : '400')};
  color: ${Palette.BLACK};

  &:hover {
    background: ${Palette.GHOST_WHITE};
  }
`;

export const SlotDurationSection = styled.div`
  align-self: stretch;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 12px;
  width: 100%;
  max-width: none;
`;

export const SlotDurationIntro = styled.div`
  align-self: stretch;
  width: 100%;
  max-width: none;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 4px;
`;

export const BlockingPanel = styled.div`
  align-self: stretch;
  width: 100%;
  max-width: none;
  box-sizing: border-box;
  padding: 20px;
  background: ${Palette.WHITE};
  border: 1px solid #a1a3ab;
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  gap: 16px;
`;

export const BlockingBlockSection = styled.div`
  align-self: stretch;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  gap: 16px;
`;

export const BlockingBlockHeader = styled.div`
  align-self: stretch;
  display: inline-flex;
  justify-content: space-between;
  align-items: center;
`;

export const BlockingBlockTitle = styled.div`
  color: ${Palette.BLACK};
  font-size: 14px;
  font-family: ${Fonts.OPEN_SANS_FONT}, sans-serif;
  font-weight: 600;
  line-height: 24px;
  text-align: left;
`;

export const BlockingRemoveButton = styled.button`
  padding: 0;
  margin: 0;
  border: none;
  background: transparent;
  cursor: pointer;
  color: ${Palette.CONTENT_NEGATIVE};
  font-size: 14px;
  font-family: ${Fonts.OPEN_SANS_FONT}, sans-serif;
  font-weight: 400;
  line-height: 24px;
  text-align: center;

  &:hover {
    text-decoration: underline;
  }

  &:focus-visible {
    outline: 2px solid ${Palette.OCEANIC};
    outline-offset: 2px;
    border-radius: 2px;
  }
`;

export const BlockingAddBlockRow = styled.button`
  align-self: flex-start;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 0;
  margin: 0;
  border: none;
  background: transparent;
  cursor: pointer;
  color: ${Palette.HAZY_BLUE};
  font-size: 14px;
  font-family: ${Fonts.OPEN_SANS_FONT}, sans-serif;
  font-weight: 400;
  line-height: 24px;
  text-align: center;

  &:focus-visible {
    outline: 2px solid ${Palette.OCEANIC};
    outline-offset: 2px;
    border-radius: 4px;
  }
`;

export const BlockingAddBlockIconWrap = styled.span`
  width: 24px;
  height: 24px;
  border-radius: 9999px;
  border: 1px solid #96a9bc;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  box-sizing: border-box;
`;

export const BookingLimitsFieldsRow = styled.div`
  align-self: stretch;
  display: flex;
  flex-direction: row;
  gap: 16px;
  width: 100%;

  @media (max-width: 480px) {
    flex-direction: column;
  }
`;

export const BookingLimitsRowErrors = styled.div`
  align-self: stretch;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  gap: 4px;
  margin-top: 4px;

  & > p {
    max-width: 100%;
  }
`;

export const BookingLimitsFieldCol = styled.div`
  flex: 1 1 0;
  min-width: 0;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 4px;
`;

export const DescriptionEditorWrap = styled.div`
  align-self: stretch;
  width: 100%;
  max-width: none;
`;

export const ScheduleWeekGrid = styled.div`
  align-self: stretch;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  gap: 16px;
  width: 100%;
  max-width: 460px;
`;

export const ScheduleDayRow = styled.div`
  align-self: stretch;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  gap: 24px;
`;

export const ScheduleDayLabelCell = styled.div`
  width: 75px;
  flex-shrink: 0;
  display: inline-flex;
  justify-content: flex-start;
  align-items: flex-end;
  gap: 8px;
  padding-left: 4px;
  box-sizing: border-box;
`;

export const ScheduleDayToggleButton = styled.button`
  width: 24px;
  height: 24px;
  padding: 0;
  border: none;
  background: transparent;
  cursor: pointer;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 999px;

  &:focus-visible {
    outline: 2px solid ${Palette.OCEANIC};
    outline-offset: 2px;
  }
`;

export const ScheduleDayToggleMark = styled.span`
  width: 20px;
  height: 20px;
  border-radius: 999px;
  box-sizing: border-box;
  background: ${({ $checked }) => ($checked ? Palette.HAZY_BLUE : 'transparent')};
  border: ${({ $checked }) => ($checked ? 'none' : `2px solid ${Palette.BRAND_DARK_BLUE}`)};
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
`;

export const ScheduleDayShortLabel = styled.span`
  color: ${Palette.BLACK};
  font-size: 14px;
  font-family: ${Fonts.OPEN_SANS_FONT}, sans-serif;
  font-weight: 600;
  line-height: 24px;
`;

export const ScheduleTimesRow = styled.div`
  flex: 1 1 0;
  min-width: 0;
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: flex-start;
  gap: 24px;

  @media (max-width: 480px) {
    flex-direction: column;
  }
`;

export const ScheduleHint = styled.div`
  color: ${Palette.CONTENT_TERTIARY};
  font-size: 12px;
  font-family: ${Fonts.OPEN_SANS_FONT}, sans-serif;
  font-weight: 400;
  line-height: 20px;
  max-width: 460px;
`;

export const ScheduleFieldColumn = styled.div`
  flex: 1 1 0;
  min-width: 0;
  align-self: stretch;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  gap: 4px;

  .ant-select {
    width: 100% !important;
  }
`;

export const WizardTextInput = styled.input`
  flex: 1;
  width: 100%;
  min-width: 0;
  border: none;
  background: transparent;
  color: ${Palette.BLACK_50};
  font-size: 14px;
  font-family: ${Fonts.OPEN_SANS_FONT}, sans-serif;
  font-weight: 400;
  line-height: 24px;
  outline: none;

  &::placeholder {
    color: ${Palette.BLACK_50};
  }

   &:focus {
    color: ${Palette.BLACK};
  }
`;

export const WizardTextArea = styled.textarea`
  flex: 1;
  width: 100%;
  min-width: 0;
  min-height: 72px;
  border: none;
  background: transparent;
  color: ${Palette.BLACK_50};
  font-size: 14px;
  font-family: ${Fonts.OPEN_SANS_FONT}, sans-serif;
  font-weight: 400;
  line-height: 24px;
  outline: none;
  resize: vertical;
  box-sizing: border-box;

  &::placeholder {
    color: ${Palette.BLACK_50};
  }

  &:focus {
    color: ${Palette.BLACK};
  }
`;

export const AmenityImagesAfterToggle = styled.div`
  align-self: stretch;
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

export const AmenityWizardNote = styled.div`
  align-self: stretch;
  width: 100%;
  padding: 8px;
  background: ${Palette.YELLOW_100};
  border-radius: 8px;
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  box-sizing: border-box;
  margin-top: 8px;
  color: ${Palette.BLACK};
  font-size: 12px;
  font-family: ${Fonts.OPEN_SANS_FONT}, sans-serif;
  font-weight: 400;
  line-height: 24px;
  word-wrap: break-word;
`;
